'use client'
import Header from "../Header";
import SingleListing from "../SingleListing";
import Reviews from "../Reviews";
import TextImageContainer from "../TextImageContainer"
import styles from '../sales.module.css';
import useMount from "react-use/lib/useMount";
import Link from "next/link";
import logPageView from "lib/ga/pageView";
import ContactForm from '../ContactForm';
import {
  reviews
} from "./data";
import Background from '../background';
const LandlordsPage = () => {
  useMount(() => {
    logPageView({ url: window.location.pathname + window.location.search });
  });

  return <>

    <Header active={'landlord'} pageTitle={'Landlords'} />
    <Background circles={
            [
                { x: 90, y: 130, type: 'medium', side: 'left' },
                { x: 150, y: 730, type: 'medium', side: 'right' },
                { x: 250, y: 1580, type: 'large', side: 'left' },
                { x: 130, y: 1930, type: 'small', side: 'right' },
                { x: 130, y: 2200, type: 'large', side: 'right' },
                { x: 130, y: 2900, type: 'medium', side: 'left' },
                { x: 130, y: 3760, type: 'medium', side: 'right' },
              ]}
            mobileCircles={
                [
                    { x: -50, y: 220, type: 'medium', side: 'right' },
                    { x: 240, y: 1440, type: 'small', side: 'left' },
                    { x: -80, y: 2480, type: 'medium', side: 'left' },
                    { x: 60, y: 4360, type: 'medium', side: 'right' },
                    
                  ]
            } zIndex={-1}  />
    <div className={styles.AgentContainer}  id='agentContainer'>

      <div className={styles.whyCompletely}>
        <h1>Why Completely Retail</h1>
        <p>Completely Retail is the UK’s leading retail property platform. We are focussed on connecting people actively seeking retail and leisure space with agents and landlords.</p>
      </div>

      <TextImageContainer link="#contactForm" img="scheme.png" greyContainer={false} id="PropertyPotential" title="Maximise your portfolio's potential" content="Market your assets under a branded portfolio with high-quality images, detailed descriptions, and interactive floor plans designed and managed by our in-house content team." />
      <TextImageContainer link="#contactForm" img="optimum.png" greyContainer={true} id="OptimumVisibility" title="Optimum visibility" content="Be the first result retailers see when they search by featuring your scheme. Enjoy prime placement in our search results, ensuring that your scheme captures the attention it deserves." />
      <TextImageContainer link="#contactForm" img="trusted-by-professionals.jpg" greyContainer={false} id="IndustryProfessionals" title="Trusted by industry professionals" content="Join a community of successful agents who use Completely Retail to connect with qualified retailers. Backed by years of industry experience, we've established ourselves as a trusted resource for retail property marketing." />
      <TextImageContainer link="#contactForm" img="Landlord_shops_to_let.png" greyContainer={true} id="UnrivalledReach" title="Unrivalled reach" content="As the highest ranking website for retail and leisure space, Completely Retail provides unmatched exposure and quality leads for retail and leisure property. Reach 1000s of prospective tenants every month, eagerly searching for their next space." />

      <Reviews reviews={reviews} />

      <h2 className={styles.marginTop}>Reach your schemes full potential</h2>

      <SingleListing abovePrice={false} title="List your scheme from" price="£750pa" content={[
        "Top search rank positions",
        "Branded portfolio page",
        "Ongoing management of your marketing materials",
        "Access to all property and scheme data"]} includeButton={false} />

      <button className={styles.contactButton}><Link prefetch={false} href="#contactForm">Contact Us</Link></button>

      <ContactForm reasons={[
        'I’d like more information about scheme sponsorship',
        'I’d like to find out more about Completely Retail',
        'I have a technical problem',
        'Other' 
      ]} />


    </div>
  </>

};

export default LandlordsPage;
